// features/landing/constants.ts — the one place the landing page's APK facts live.
//
// The APK itself is served by Caddy (`handle /download/*` → host ./download),
// entirely outside the SPA — so when a new build lands in that directory this
// constant must be bumped by hand, and nothing else in src/ may hardcode the
// path. There must never be a SPA route named `download`: Caddy owns the
// prefix, and LandingPage.test.tsx pins that absence.

export const APK_DOWNLOAD_URL = '/download/TruXSocial-1.26.60.apk';

/** Version string shown on the download card — keep in step with the file above. */
export const APK_VERSION = '1.26.60';

/** Approximate installer size shown on the download card. */
export const APK_SIZE_LABEL = '69.8 MB';
